import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import LayoutSidebar from '../components/LayoutSidebar'

export default function PageNotAvailable({ type }) {
  const [message, setMessage] = useState();
  const navigate = useNavigate()

  const goHome = () => {
    navigate('/home');
  }

  useEffect(() => {
    if (type === 404) {
      setMessage('Page Not Found');
    } else if (type === 403) {
      setMessage('Permission Denied');
    } else if (type === 'Maintenance') {
      setMessage("The application is down for maintenance. Please try again shortly by clicking the 'Home page' button");
    }
  }, [type]);

  const goBack = () => {
    navigate(-2);
  }

  return (
    <LayoutSidebar
      id={false}
      contentTitle={message}
      content={(
        <div className="lox-page-not-available container">
          <div className="columns is-align-items-center is-justify-content-center">
            <div className="section">
              <h1 className="is-size-1">{type}</h1>
              <h2 className="is-size-3">{message}</h2>
              <div className="buttons mt-5">
                <button
                  type="button"
                  onClick={goHome}
                  className="button is-primary p-4"
                >
                  Home page
                </button>
                <button
                  type="button"
                  onClick={goBack}
                  className="button is-primary p-4"
                >
                  Back
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      dashlets={false}
    />
  )
}
